if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
            this.productElement.classList.forEach((classApplied) => {
              if (classApplied.startsWith('color-') || classApplied === 'gradient')
                this.modalContent.classList.add(classApplied);
            });
            
            
            this.customElementsQuickAddDrawer();
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            // Inject KaChing bundle widget into the Quick Add modal after Ajax HTML is inserted
            // Note: KaChing app embed must be enabled so the web component + initializer are available on this page
            this.injectKachingBundle();

            // Re-initialize KaChing after Ajax content injection
            this.refreshKaching();


if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            // commented the function below for custom fetching of product section
            //this.updateImageSizes();
            this.preventVariantURLSwitching();
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      getProductIdForKaching() {
        // Try a few common places where Dawn based themes expose the product id

        // 1) <product-info data-product-id="...">
        const productInfo = this.productElement?.querySelector('product-info');
        const idFromProductInfo = productInfo?.dataset?.productId;
        if (idFromProductInfo) return idFromProductInfo;

        // 2) Any element with data-product-id
        const anyDataEl = this.productElement?.querySelector('[data-product-id]');
        const idFromAnyData = anyDataEl?.getAttribute('data-product-id');
        if (idFromAnyData) return idFromAnyData;

        // 3) Product JSON script (common pattern)
        const jsonScript = this.productElement?.querySelector('script[type="application/json"][id*="ProductJson"], script[type="application/json"][data-product-json]');
        if (jsonScript?.textContent) {
          try {
            const parsed = JSON.parse(jsonScript.textContent);
            const idFromJson = parsed?.product?.id || parsed?.id;
            if (idFromJson) return String(idFromJson);
          } catch (e) {
            // ignore
          }
        }

        // 4) Sometimes the section wrapper carries the id
        const section = this.productElement?.querySelector('[id^="MainProduct-"]');
        const idFromSection = section?.dataset?.productId || section?.getAttribute('data-product-id');
        if (idFromSection) return idFromSection;

        return null;
      }

      waitForKachingAnchor() {
        // Prefer placing it above the product form
        const productForm = this.modalContent.querySelector('product-form');
        if (productForm) return { anchor: productForm, mode: 'before' };

        // Fallback: inside the info container
        const infoContainer = this.modalContent.querySelector('.product__info-container');
        if (infoContainer) return { anchor: infoContainer, mode: 'append' };

        return null;
      }

      refreshKaching() {
        if (typeof window.kachingBundlesInitialize === 'function') {
          window.kachingBundlesInitialize();
        }
      }

      injectKachingBundle() {
        if (window.SybotanicaB2B && window.SybotanicaB2B.isB2B) return;
        // If KaChing is already present in the injected HTML, do nothing
        if (this.modalContent.querySelector('kaching-bundle')) return;

        const tryInject = () => {
          const productId = this.getProductIdForKaching();
          const placement = this.waitForKachingAnchor();

          if (!productId || !placement) return false;

          const bundleEl = document.createElement('kaching-bundle');
          bundleEl.setAttribute('product-id', productId);

          if (placement.mode === 'before' && placement.anchor.parentNode) {
            placement.anchor.parentNode.insertBefore(bundleEl, placement.anchor);
          } else {
            placement.anchor.appendChild(bundleEl);
          }

          // Ensure any Web Components upgrade after Ajax injection
          const upgrade = () => {
            if (window.customElements && typeof customElements.upgrade === 'function') {
              customElements.upgrade(this.modalContent);
            }

            // Some widgets only render properly if the element is re-attached after definition
            const existing = this.modalContent.querySelector('kaching-bundle');
            if (existing) {
              const clone = existing.cloneNode(true);
              existing.replaceWith(clone);
            }
          };

          // If the custom element is not defined yet on this page, wait for it
          if (window.customElements && typeof customElements.whenDefined === 'function') {
            customElements.whenDefined('kaching-bundle').then(() => upgrade()).catch(() => upgrade());
          } else {
            upgrade();
          }

          this.refreshKaching();

          return true;
        };

        // Try immediately
        if (tryInject()) return;

        // Try on next frame (hydration timing)
        requestAnimationFrame(() => {
          if (this.modalContent.querySelector('kaching-bundle')) return;
          if (tryInject()) return;

          // Final attempt: observe DOM mutations briefly
          const obs = new MutationObserver(() => {
            if (this.modalContent.querySelector('kaching-bundle')) {
              obs.disconnect();
              return;
            }
            if (tryInject()) {
              obs.disconnect();
            }
          });

          obs.observe(this.modalContent, { childList: true, subtree: true });

          // Safety disconnect
          setTimeout(() => obs.disconnect(), 1500);
        });
      }

      injectKachingBundle() {
        // If KaChing is already present in the injected HTML, do nothing
        if (this.modalContent.querySelector('kaching-bundle')) return;

        const productId = this.getProductIdForKaching();
        if (!productId) return;

        const bundleEl = document.createElement('kaching-bundle');
        bundleEl.setAttribute('product-id', productId);

        // Prefer placing it right above the product form (where quantity/ATC normally live)
        const productForm = this.modalContent.querySelector('product-form');
        if (productForm && productForm.parentNode) {
          productForm.parentNode.insertBefore(bundleEl, productForm);
        } else {
          // Fallback: place it inside the info container
          const infoContainer = this.modalContent.querySelector('.product__info-container');
          if (infoContainer) {
            infoContainer.appendChild(bundleEl);
          } else {
            this.modalContent.appendChild(bundleEl);
          }
        }

        // Ensure any Web Components upgrade after Ajax injection
        if (window.customElements && typeof customElements.upgrade === 'function') {
          customElements.upgrade(this.modalContent);
        }
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
        if (!variantPicker) return;

        variantPicker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = this.productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
          element.dataset.originalSection = sectionId;
        });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        const desktopColumns = product.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }


      // Function to customize the element inside quick add drawer
      // customElementsQuickAddDrawer(){

      //   const productInfoContainer = this.productElement.querySelector('.product__info-container');
      //   const breadcrumbs = this.productElement.querySelector('.nf-breadcrumb');
      //   const nfBadge =  this.productElement.querySelector('.nf-badge-container');
      //   const productButton = this.productElement.querySelector('product-form');
      //   const productButtonMobile =  this.productElement.querySelector('#mobile-form');
      //   const productTitle = this.productElement.querySelector('.product__title');
      //   const productPrice = this.productElement.querySelector('.price');
      //   productPrice.parentNode.classList.add('quick-add-price-element');
      //   const quickAddPriceElement = this.productElement.querySelector('.quick-add-price-element');
      //   const productText = this.productElement.querySelector('.product__text');
      //   const productShorDescription = this.productElement.querySelector('#pdp-short-description');
      //   const uspProductCard = this.productElement.querySelector('.usp-product-card');
      //   const uspWrap = this.productElement.querySelectorAll('.usp-wrap');
      //   const mostSuitedFor = this.productElement.querySelector('.most-suited-for-drawer-icon');
      //   const mediaWrapper = this.productElement.querySelector('.product__media-wrapper');
      //   const mediaGallery = this.productElement.querySelector('media-gallery');
      //   const viewFullDetail = this.productElement.querySelector('.product__view-details');
      //   const stockWrapper = this.productElement.querySelector('#stock-text-wrapper');
      //   const productPayment = this.productElement.querySelector('.product__payment');
      //   const optionExplanation = this.productElement.querySelector('.explanation-dialog-btn');
      //   const inputRadioMostPrequentylyChosen = this.productElement.querySelector('input[most-frequently-chosen="true"]');
      //   const pdpKlaviyoBtn = this.productElement.querySelector('.klaviyo-bis-trigger');
      

      //   //app blocks
      //   const trustPilotWidget =  this.productElement.querySelector('.trustpilot-widget');
      //   const estimatedShippingWidget =  this.productElement.querySelector('.ot-estimated-shipping');
      //   const judgemePreviewBadge =  this.productElement.querySelector('.jdgm-preview-badge');
      //   judgemePreviewBadge.parentNode.classList.add('jdgm-preview-badge-container');
      //   const judgemePreviewBadgeContainer = this.productElement.querySelector('.jdgm-preview-badge-container');

      //   if(inputRadioMostPrequentylyChosen) {
      //     const inputRadioMostPrequentylyChosenVariantId = inputRadioMostPrequentylyChosen.getAttribute('most-frequently-chosen-variant-id');
      //     this.productElement.querySelector('.product-variant-id').setAttribute('value', inputRadioMostPrequentylyChosenVariantId);
      //   }

      //   if(breadcrumbs){
      //     breadcrumbs.remove();
      //   }

      //   if(nfBadge){
      //     nfBadge.remove();
      //   }

      //   if(productButtonMobile){
      //     productButtonMobile.remove();
      //   } 

      //   if(productTitle){
      //     productTitle.remove();
      //   }
        

      //   if(quickAddPriceElement){
      //     quickAddPriceElement.remove();
      //   }
        

      //   if(productText){
      //     productText.remove();
      //   }
        

      //   if(productShorDescription){
      //     productShorDescription.remove();
      //   }
        
        
      //   if(uspProductCard){
      //     uspProductCard.remove();
      //   }

      //   // if(mostSuitedFor) {
      //   //   mostSuitedFor.remove();
      //   // }
       

      //   if(mediaWrapper){
      //     mediaWrapper.remove();
      //   }
        

      //   if(mediaGallery){
      //     mediaGallery.remove();
      //   }
        

      //   if(viewFullDetail) {
      //     viewFullDetail.remove();
      //   }

      //   if(stockWrapper){
      //     stockWrapper.remove();
      //   }

      //   if(productPayment){
      //     productPayment.remove();
      //   }

      //   // if(optionExplanation){
      //   //   optionExplanation.remove();
      //   // }

      //   if(uspWrap){
      //     uspWrap.forEach((usp) => {
      //       usp.remove();
      //     });
      //   }

      //   if(trustPilotWidget) {
      //     trustPilotWidget.remove();
      //   }

      //   if(estimatedShippingWidget) {
      //     estimatedShippingWidget.remove();
      //   }

      //   if(judgemePreviewBadgeContainer){
      //     judgemePreviewBadgeContainer.remove();
      //   }

      //   if(pdpKlaviyoBtn) {
      //     pdpKlaviyoBtn.remove();
      //   }

      //   const producttitleAndImage = document.createElement('div');
      //   producttitleAndImage.classList.add('main-product-drawer-image');
      //   const productTitleAndPrice = document.createElement('div');
      //   productTitleAndPrice.classList.add('main-product-drawer-title-price');

      //   productTitleAndPrice.appendChild(productTitle);
      //   productTitleAndPrice.appendChild(productText);
      //   productTitleAndPrice.appendChild(quickAddPriceElement);
      //   //productTitleAndPrice.appendChild(judgemePreviewBadgeContainer);
      //   productTitleAndPrice.appendChild(viewFullDetail);

      //   producttitleAndImage.appendChild(mediaGallery);
      //   producttitleAndImage.appendChild(productTitleAndPrice);
        
      //   productInfoContainer.prepend(producttitleAndImage);

      // }

      customElementsQuickAddDrawer() {
        // Helper function to safely manipulate elements
        const safeOperation = (element, operation) => {
          if (element) {
            operation(element);
          }
        };
      
        // Get all elements with null checks
        const productInfoContainer = this.productElement.querySelector('.product__info-container');
        const breadcrumbs = this.productElement.querySelector('.nf-breadcrumb');
        const nfBadge = this.productElement.querySelector('.nf-badge-container');
        const productButton = this.productElement.querySelector('product-form');
        const productButtonMobile = this.productElement.querySelector('#mobile-form');
        const productTitle = this.productElement.querySelector('.product__title');
        const productPrice = this.productElement.querySelector('.price');
        const productText = this.productElement.querySelector('.product__text');
        const productShorDescription = this.productElement.querySelector('#pdp-short-description');
        const uspProductCard = this.productElement.querySelector('.usp-product-card');
        const uspWrap = this.productElement.querySelectorAll('.usp-wrap');
        const mostSuitedFor = this.productElement.querySelector('.most-suited-for-drawer-icon');
        const mediaWrapper = this.productElement.querySelector('.product__media-wrapper');
        const mediaGallery = this.productElement.querySelector('media-gallery');
        const viewFullDetail = this.productElement.querySelector('.product__view-details');
        const stockWrapper = this.productElement.querySelector('#stock-text-wrapper');
        const productPayment = this.productElement.querySelector('.product__payment');
        const optionExplanation = this.productElement.querySelector('.explanation-dialog-btn');
        const pdpKlaviyoBtn = this.productElement.querySelector('.klaviyo-bis-trigger');
      
        // App blocks
        const trustPilotWidget = this.productElement.querySelector('.trustpilot-widget');
        const estimatedShippingWidget = this.productElement.querySelector('.ot-estimated-shipping');
        const judgemePreviewBadge = this.productElement.querySelector('.jdgm-preview-badge');
      
        // Safe operations for elements that might not exist
        if (productPrice) {
          productPrice.parentNode.classList.add('quick-add-price-element');
        }
        
        const quickAddPriceElement = this.productElement.querySelector('.quick-add-price-element');
        
        if (judgemePreviewBadge && judgemePreviewBadge.parentNode) {
          judgemePreviewBadge.parentNode.classList.add('jdgm-preview-badge-container');
        }
        
        const judgemePreviewBadgeContainer = this.productElement.querySelector('.jdgm-preview-badge-container');
      
        // We no longer override the product-variant-id based on "most frequently chosen".
        // Handle most frequently chosen variant
      //  if (inputRadioMostPrequentylyChosen) {
      //    const inputRadioMostPrequentylyChosenVariantId = inputRadioMostPrequentylyChosen.getAttribute('most-frequently-chosen-variant-id');
     //    const variantIdElement = this.productElement.querySelector('.product-variant-id');
     //     if (variantIdElement) {
    //       variantIdElement.setAttribute('value', inputRadioMostPrequentylyChosenVariantId);
     //     }
     //   }
      
        // Remove elements safely
        safeOperation(breadcrumbs, el => el.remove());
        safeOperation(nfBadge, el => el.remove());
        safeOperation(productButtonMobile, el => el.remove());
        safeOperation(productTitle, el => el.remove());
        safeOperation(quickAddPriceElement, el => el.remove());
        safeOperation(productText, el => el.remove());
        safeOperation(productShorDescription, el => el.remove());
        safeOperation(uspProductCard, el => el.remove());
        safeOperation(mediaWrapper, el => el.remove());
        safeOperation(mediaGallery, el => el.remove());
        safeOperation(viewFullDetail, el => el.remove());
        safeOperation(stockWrapper, el => el.remove());
        safeOperation(productPayment, el => el.remove());
        safeOperation(trustPilotWidget, el => el.remove());
        safeOperation(estimatedShippingWidget, el => el.remove());
        safeOperation(judgemePreviewBadgeContainer, el => el.remove());
        safeOperation(pdpKlaviyoBtn, el => el.remove());
      
        // Remove each USP wrap element
        if (uspWrap && uspWrap.length > 0) {
          uspWrap.forEach(usp => {
            if (usp) usp.remove();
          });
        }
      
        // Create new elements structure safely
        if (productInfoContainer) {
          const producttitleAndImage = document.createElement('div');
          producttitleAndImage.classList.add('main-product-drawer-image');
          
          const productTitleAndPrice = document.createElement('div');
          productTitleAndPrice.classList.add('main-product-drawer-title-price');
      
          // Append children only if they exist
          safeOperation(productTitle, el => productTitleAndPrice.appendChild(el));
          safeOperation(productText, el => productTitleAndPrice.appendChild(el));
          safeOperation(quickAddPriceElement, el => productTitleAndPrice.appendChild(el));
          safeOperation(viewFullDetail, el => productTitleAndPrice.appendChild(el));
      
          safeOperation(mediaGallery, el => producttitleAndImage.appendChild(el));
          producttitleAndImage.appendChild(productTitleAndPrice);
          
          productInfoContainer.prepend(producttitleAndImage);
        }
      }

    }
  );
}
